import { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Button, Spinner, Text } from '@nimbus-ds/components';
import { useNavegate } from 'App/hooks';
import { useToast } from 'commons/hooks';
import {
  trackingOrderListNewCreditPromotionBannerAcceptClick,
  trackingOrderListNewCreditPromotionBannerClose,
  trackingOrderListNewCreditPromotionBannerView,
} from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { partnersAppsRoutes } from 'domains/PartnersApps';
import { useGetNuvemEnvioConfigs } from 'domains/Shipping/DeliveryMethods/hooks';
import useUpdateNuvemEnvioConfigs from 'domains/Shipping/DeliveryMethods/hooks/useUpdateNuvemEnvioConfigs';
import { NE_DISPLAY_SWITCHES, NE_WELCOME_CREDIT_PROMOTION } from '../constants';

function NuvemEnvioWelcomeCreditCommunication() {
  const t = useTranslationOrders();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const { goTo } = useNavegate();
  const { addToast } = useToast();

  const { fetchNuvemEnvioConfigs, nuvemEnvioConfigs } =
    useGetNuvemEnvioConfigs();

  const {
    acceptNuvemEnvioWelcomeCreditPromotion,
    updateNuvemEnvioDisplaySwitches,
  } = useUpdateNuvemEnvioConfigs();

  const handleAcceptPromotion = async () => {
    setLoading(true);
    const response = await acceptNuvemEnvioWelcomeCreditPromotion(
      NE_WELCOME_CREDIT_PROMOTION,
    );

    trackingOrderListNewCreditPromotionBannerAcceptClick();

    acceptPromotionHandler(response);
  };

  const acceptPromotionHandler = useCallback(
    (response) => {
      setLoading(false);
      if (response.error) {
        addToast({
          label: t('nuvemEnvio.welcome-credit-promotion-banner.error'),
          appearance: 'danger',
        });
        setLoading(false);
        return;
      }

      setVisible(false);
      fetchNuvemEnvioConfigs();
      goTo(
        `${partnersAppsRoutes.nuvemenvio}/#/dashboard?activatePromotionSuccess=true`,
      );
    },
    [addToast, fetchNuvemEnvioConfigs, goTo, t],
  );

  const handleClose = async () => {
    try {
      setVisible(false);
      await updateNuvemEnvioDisplaySwitches(
        NE_DISPLAY_SWITCHES.WELCOME_CREDIT_PROMOTION_BANNER,
      );
      trackingOrderListNewCreditPromotionBannerClose();

      fetchNuvemEnvioConfigs();
    } catch (error) {
      addToast({
        label: t('nuvemEnvio.welcome-credit-promotion-banner.error-close'),
        appearance: 'danger',
      });
    }
  };

  useEffect(() => {
    if (nuvemEnvioConfigs.displaySwitches.welcomeCreditPromotionBanner) {
      setVisible(true);
      trackingOrderListNewCreditPromotionBannerView();
    }
  }, [nuvemEnvioConfigs.displaySwitches.welcomeCreditPromotionBanner]);

  if (!nuvemEnvioConfigs.displaySwitches.welcomeCreditPromotionBanner) {
    return null;
  }

  return (
    <Box>
      <Alert
        appearance="primary"
        title={t('nuvemEnvio.welcome-credit-promotion-banner.title')}
        onRemove={handleClose}
        show={visible}
      >
        <Text>{t('nuvemEnvio.welcome-credit-promotion-banner.text')}</Text>
        <Button onClick={handleAcceptPromotion} disabled={loading}>
          {loading && <Spinner size="small" />}
          {t('nuvemEnvio.welcome-credit-promotion-banner.button')}
        </Button>
      </Alert>
    </Box>
  );
}

export default NuvemEnvioWelcomeCreditCommunication;
